<template>
    <div class="Page" v-if="State">
        <Header :Act="State"></Header>
        <div class="MaxWid">
            <div class="MarTop">
                <div class="AboutPos" @click="Back">当前位置：{{State==5?'继续教育':State==6?'信息动态':'职业伦理'}}</div>
            </div>
            <div class="Cont" v-if="Data">
                <div class="title">{{Data.name}}</div>
                <div class="ContDis">
                    <div class="Flex">发布时间：{{formatTime(Data.updatetime)}}</div>
                    <div class="Flex">状态：{{Data.status_text}}</div>
                </div>
                <div class="ContHead" v-html="Data.content"></div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from '@/components/header/head';
    import Footer from '@/components/header/footer';
    export default {
        components: {Header,Footer},
        data() {
            return {
                Data:"",
                State:"",
            }
        },
        mounted() {
            this.Data = JSON.parse(localStorage.getItem("Info"));
            console.log(this.Data);
            this.State = localStorage.getItem("InfoState");
        },
        methods: {
            Back(){
                this.$router.go(-1)
            },
            formatTime(timestamp) {
                if (!timestamp) return '';
                // 将秒级时间戳转换为毫秒级
                const date = new Date(timestamp * 1000);
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                return `${year}-${month}-${day}`;
            }
        },
    }
</script>
<style scoped>
    .Page {
        background: #fff;
    }
    
    .BgColorBlue {
        background-color: #037dbe;
    }
    
    .BgColorYellow {
        background-color: #ed8404;
    }
    
    .BgColorGreen {
        background-color: #82ae1d;
    }
    
    .MarTop {
        margin-top: 20px;
    }
    .MaxWid {
        max-width: 1180px;
        padding: 0 10px;
        margin: 0 auto;
    }
    .AboutPos{
        padding: 20px 0;
        font-size: 12px;
        color: #999999;
        cursor: pointer;
    }
    .title{
        padding: 20px 0;
        text-align: center;
        font-size: 18px;
    }
    .ContDis{
        display: flex;
        align-items: center;
        justify-content: center;
        border-bottom: 1px solid #ddd;
    }
    .ContDis .Flex{
        width: 30%;
        font-size: 14px;
        color: #666;
        padding-bottom:20px;
        text-align: center;
    }
    .ContHead{
        margin: 20px 0;
        width: 100%;
    }
</style>